import RenderInputs from './render-inputs';
import PCP from '../../../finance/finance-product-objects/pcp';

export default class extends PCP {
    constructor(vehicle) {
        super(vehicle);
        this.renderer = new RenderInputs(vehicle, this);
    }

    getAllowedTerms() {
        // const terms = [];
        // for (let index = 24; index < 48; index++) {
        //     terms.push(index);
        // }
        // return terms;
        return this.renderer.getAllowedTerms();
    }

    getAllowedDeposit() {
        return this.renderer.getAllowedDeposit();
    }

    getAllowedMileages() {
        return this.renderer.getAllowedMileages();
    }

    /**
     * Renders the sliders and sets the select box contents
     */
    init(customerParameters) {
        this.renderer.renderTermInputs(customerParameters);
        this.renderer.renderDepositInputs(customerParameters);
        this.renderer.renderMileageInputs(customerParameters);
    }

    render(codeweaversResponse, originalRequest) {
        let quote = codeweaversResponse.getFinanceProductOfInterest(this);
        if (quote.error == true) {
            console.error('quote wasnt defined', quote);
            return;
        }

        dataLayer.push({
            'event': 'financeQuote',
            'monthly-payment': quote.getMonthlyPayment(),
            'quote-type': this.pseudoKey,
        });

        return super.render(codeweaversResponse, originalRequest);
    }

    constrain(constraint) {
        this.renderer.constrain(constraint);
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/details/finance/finance-types/pcp.js